// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"SearchBar_inputSearch__3BjcZ","btnSearch":"SearchBar_btnSearch__1cfpO"};